var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.gestoraion.com","target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"powered-by"},[_vm._v(" powered by "),_c('span',[_vm._v("AION")])])])
}]

export { render, staticRenderFns }